import apiClient from '../apiClient';
import { DELETE_TRANSPORTATION_BY_PROFILE_ID_URL } from '../apiUrl';

const deleteTransportationByProfileIdApi = Id => {
  return apiClient.delete(DELETE_TRANSPORTATION_BY_PROFILE_ID_URL(Id));
};

export default deleteTransportationByProfileIdApi;
